export default function TermsOfService() {
  return (
    <iframe
      src={`/htm/termsOfService.html`}
      style={{ width: '100vw', height: '100vh', border: 'none' }}
    ></iframe>
  )
}
